import { AsyncPipe } from '@angular/common';
import { Component, Input } from '@angular/core';
import { LoaderSpinerService } from '@services/loader-spiner.service';

@Component({
    selector: 'app-loader-spinner',
    templateUrl: './loader-spinner.component.html',
    imports: [AsyncPipe],
    styleUrl: './loader-spinner.component.scss'
})
export class LoaderSpinnerComponent {
  message = 'Carregando...';
  loaderSpiner$ = this.loaderSpiner.loaderSpiner$;

  constructor(private loaderSpiner: LoaderSpinerService) { }

}
